import React from 'react';
import styled from 'styled-components';

const StatusesWrapper = styled.div`
	display: inline-block;
`;

export const statuses = {
	'draft': (
		<StatusesWrapper>Чернетка</StatusesWrapper>
	),
	'public': (
		<StatusesWrapper>Оприлюднений</StatusesWrapper>
	),
	'archive': (
		<StatusesWrapper>Архівний</StatusesWrapper>
	),
	'service': (
		<StatusesWrapper>Службовий</StatusesWrapper>
	)
};



// WEBPACK FOOTER //
// ./src/admin/documents/statuses.js